import PropTypes from 'prop-types'
import React from 'react'
import { AdApi } from 'SRC/modules/ads/shared/api'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { setProfileAdsError, fetchUserInfo } from 'SRC/modules/users/Profile/actions'
import { updateAdById, removeAdFromPaid } from '../../../../actions'
import { connect } from 'react-redux'
import { adsStatues } from 'SRC/modules/ads/shared/constants'

export class MarkSold extends React.PureComponent {
  markAsSold = async () => {
    if (this.props.isAvailable) {
      const helper = new CookiesHelper()
      const token = helper.get('token')
      const userId = helper.get('userId')
      const adId = this.props.adId
      if (token && userId && adId) {
        this.props.updateAdById(adId, {isLoading: true})
        const fields = {token, userId, adId}
        const api = new AdApi()
        const {status, message} = await api.markAdAsSold(fields)
        if (status === AdApi.responseTypes.OK) {
          if (this.props.isPaid) {
            this.props.removeAdFromPaid(adId)
          }
          this.props.updateAdById(adId, {status: adsStatues.SOLD.code, isLoading: false})
          this.props.fetchUserInfo(userId, token, true)
        } else {
          this.props.setProfileAdsError(message)
          this.props.updateAdById(adId, {isLoading: false})
        }
      }
    }
  }

  render () {
    const {isAvailable} = this.props
    return (
      <div className={`moji-oglasi-akcije-item ${isAvailable ? `` : `disabled`}`}>
        <a href='javascript:void(0)' onClick={this.markAsSold}><i className='ico-prodat-oglas ico' /> Prodato</a>
      </div>
    )
  }
}

MarkSold.propTypes = {
  isAvailable: PropTypes.bool.isRequired,
  adId: PropTypes.number.isRequired,
  setProfileAdsError: PropTypes.func.isRequired,
  updateAdById: PropTypes.func.isRequired,
  isPaid: PropTypes.bool.isRequired,
  removeAdFromPaid: PropTypes.func.isRequired,
  fetchUserInfo: PropTypes.func.isRequired
}

MarkSold.defaultProps = {
  isAvailable: true,
  isPaid: false
}

export default connect(null, {setProfileAdsError, updateAdById, removeAdFromPaid, fetchUserInfo})(MarkSold)
